var _polygon, _polygon2, _rect, _polygon3, _rect2, _polyline, _line, _line2, _rect3, _polyline2, _polyline3, _rect4, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    enableBackground: "new 0 0 23 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "20.5,8.5 18.5,8.5 18.5,4 10.5,0.5 2.5,4 2.5,10.5 0.5,10.5 0.5,14.5 2.5,15.5 2.5,19 10.5,23.5  18.5,18.875 18.5,16.5 20.5,16.5 22.5,14 22.5,11 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEE3E1",
    points: "22.5,12.5 22.5,14 20.5,16.5 20.5,12.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12.5,
    fill: "#FEE3E1",
    width: 2,
    height: 4
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEE3E1",
    points: "2.5,6 2.5,9.5 5.5,7.5 5.5,5 13,8.5 18.5,7 18.5,6 10.5,2.5 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.5,
    fill: "#FEE3E1",
    width: 4,
    height: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "2.5,10.5  0.5,10.5 0.5,14.5 2.5,15.5 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 7.5,
    y1: 11.5,
    x2: 7.5,
    y2: 12.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.5,
    y1: 11.5,
    x2: 13.5,
    y2: 12.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.5,
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 4,
    height: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "13.5,18.5  19.5,18.5 19.5,16.5 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "18.5,8.5  18.5,4 10.5,0.5 2.5,4 2.5,19 10.5,23.5 15.669,20.5 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 8.5,
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 2,
    height: 8
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "20.5,8.5  22.5,11 22.5,14 20.5,16.5 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F9423A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "18.5,7  13,8.5 5.5,5 5.5,7.5 2.5,9.5 2.5,4 10.5,0.5 18.5,4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactHeader);
export default __webpack_public_path__ + "static/media/contact-header.ba5d7a59ae0255ed6cb7a3598e3ed5b4.svg";
export { ForwardRef as ReactComponent };